import PropTypes from "prop-types";
import InputBase from "./InputBase";
import ConstrainBase from "../../../model/validate/ConstrainBase";
import {TextField} from "@mui/material";
import GF from "../../../../lib/utils/GF";

class InputText extends InputBase {

  getValue() {
    return this.inputElementRef.current.value;
  }

  render() {
    let {
      variant = 'outlined',
      type = 'text',
      disabled,
      regex,
      multiline,
      labelElement,
      defaultValue,
      id,
      size,
      helpTextElement,
      sx,
      minRows,
      onKeyDown,
      autoFocus,
      placeholder,
      maxLength
    } = this.props;

    if (maxLength === 0 || !maxLength) {
      maxLength = 255;
    }

    const hasError = !!this.state.errorText;
    return <TextField
      variant={variant}
      id={id}
      size={size}
      type={type}
      regex={regex}
      minRows={minRows}
      sx={sx}
      onKeyDown={onKeyDown}
      helperText={hasError ? this.state.errorText : helpTextElement}
      error={hasError}
      autoFocus={autoFocus}
      placeholder={placeholder}
      fullWidth
      disabled={disabled}
      multiline={multiline}
      onChange={(e) => { this.clearError(); this.fireOnChange(e); }}
      onBlur={(e) => this.onBlur(e.target.value)}
      label={labelElement}
      defaultValue={defaultValue}
      inputRef={this.inputElementRef}
      maxRows={GF.getValue(this.props.maxRows, undefined)}
      slotProps={{
        input: {maxLength: maxLength},
      }}
      inputProps={{maxLength: maxLength}}/>;
  }
}

InputText.propTypes = {
  labelElement: PropTypes.any,
  helpTextElement: PropTypes.node,
  state: PropTypes.oneOf(['none', 'enable', 'disable', 'error', 'readonly']),
  variant: PropTypes.oneOf(['outlined', 'filled', 'standard']),
  defaultValue: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  constrain: PropTypes.objectOf(ConstrainBase),
  type: PropTypes.oneOf(['text', 'password', 'email', 'phone', 'number']),
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  multiline: PropTypes.bool,
  regex: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
}
export default InputText;
